import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SendViol3ArbetsorderCommand extends BasicCommand<SendViol3ArbetsorderCommand> {
    get primaryKey(): IPrimaryKey<SendViol3ArbetsorderCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SendViol3ArbetsorderCommand";
    constructor(arbetsorderId: number) {
        super(SendViol3ArbetsorderCommand.$type, "Arbetsorder", CommandType.Replace);
        this.arbetsorderId = arbetsorderId;
    }
}
